import React, { useContext, useState } from "react";
import "./RequestRecords.css";
import RegisterClient from "../../RegisterClient/RegisterClient";
import { UserContext } from "./../../../context/UserContext";
import useClients from "./../../../hooks/useClients";
import ClientInfo from "../Clients/ClientInfo/ClientInfo";

export default function RequestRecords({ onBack }) {
  const [filterGroup, setFilterGroup] = useState("");
  const [searchText, setSearchText] = useState("");
  const [showRegisterScreen, setShowRegisterScreen] = useState(false);
  const [showClientInfoScreen, setShowClientInfoScreen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  const {
    user: { id },
  } = useContext(UserContext);

  // const clients = [
  //   {
  //     first: "Alice",
  //     last: "Brown",
  //     email: "alice@xyz.com",
  //     dob: "1985-05-10",
  //     file: "CLT-12345",
  //     group: "A",
  //   },
  //   {
  //     first: "Bob",
  //     last: "Smith",
  //     email: "bob@xyz.com",
  //     dob: "1990-08-22",
  //     file: "CLT-23456",
  //     group: "B",
  //   },
  //   {
  //     first: "Carol",
  //     last: "Jones",
  //     email: "carol@xyz.com",
  //     dob: "1978-12-01",
  //     file: "CLT-34567",
  //     group: "A",
  //   },
  // ];

  const { clients } = useClients(id);
  console.log(clients);

  const handleRowClick = (c) => {
    setShowClientInfoScreen(true);
    setSelectedClient(c);
  };

  if (showClientInfoScreen) {
    return (
      <ClientInfo
        selectedClient={selectedClient}
        onBack={() => setShowClientInfoScreen(false)}
      />
    );
  }

  const handleNewClientRegistration = () => {
    setShowRegisterScreen(true);
  };

  if (showRegisterScreen) {
    return <RegisterClient onBack={() => setShowRegisterScreen(false)} />;
  }

  return (
    <div className="request-records-page">
      <button className="rr-back" onClick={onBack}>
        ← Back to Dashboard
      </button>

      <div className="rr-header">
        <h2 className="rr-title">Clients</h2>
        <div className="rr-header-actions">
          <button
            className="rr-btn rr-btn-new"
            onClick={handleNewClientRegistration}
          >
            New Client
          </button>
          <button className="rr-btn rr-btn-options">Options ▼</button>
        </div>
      </div>

      <div className="rr-banner">
        <div className="rr-banner-content">
          <strong className="rr-banner-title">Making Requests</strong>
          <span className="rr-banner-text">
            To begin your record request, select a client from the list below.
            You can then select your provider and products and immediately place
            the request if all authorizations have been approved.
          </span>
        </div>
        <button className="rr-banner-close">×</button>
      </div>

      <div className="rr-card">
        <h3 className="rr-card-title">Clients List</h3>

        <div className="rr-filters">
          <select
            className="rr-select"
            value={filterGroup}
            onChange={(e) => setFilterGroup(e.target.value)}
          >
            <option value="">Filter groups</option>
            <option value="A">Group A</option>
            <option value="B">Group B</option>
            <option value="C">Group C</option>
          </select>

          <input
            type="text"
            className="rr-input"
            placeholder="Search client name or file #"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <table className="rr-table">
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>DOB</th>
              <th>File Number</th>
              <th>Groups</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((c) => (
              <tr
                key={c.id}
                className="c-table-row"
                onClick={() => handleRowClick(c)}
              >
                <td>{c.first_name}</td>
                <td>{c.last_name}</td>
                <td>{c.email || "-"}</td>
                <td>{c.dob?.split("T")[0]}</td>
                <td>{c.file_number}</td>
                <td>{"N/A"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="rr-pagination">
          <label>
            Show
            <select defaultValue="10">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            entries
          </label>
        </div>
      </div>
    </div>
  );
}
